// extracted by mini-css-extract-plugin
module.exports = {"triggerNoHover":"ChatHeader_triggerNoHover__sg59y","triggerSelectable":"ChatHeader_triggerSelectable__9DTxF"};